<template>
  <div>
    <el-card class="">
      <div slot="header" class="flex justify-between">
        <span>同步商品</span>
        <div>
          <el-button type="primary" size="small" @click="openAddShopHouseModal">
            <i class="el-icon-plus"></i>选择商品
          </el-button>
        </div>
      </div>

      <el-table :data="transferPartnerGoodsInfo.products" border style="width: 100%">
        <el-table-column prop="coverPhoto" label="商品图片" align="center">
          <template slot-scope="scope">
            <img style="width: 60px; height: 60px; border-radius: 5px;" :src="scope.row.coverPhoto">
          </template>
        </el-table-column>
        <el-table-column prop="productId" label="编号" align="center"></el-table-column>
        <el-table-column prop="prodName" label="名称" align="center"></el-table-column>
        <el-table-column prop="specName" label="规格" align="center"></el-table-column>
        <el-table-column prop="stock" label="库存" align="center"></el-table-column>
        <el-table-column prop="price" label="单价" align="center"></el-table-column>
        <el-table-column label="操作" align="center">
          <template slot-scope="scope">
            <el-button size="mini" type="danger" @click="deleteProduct(scope.row)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>

      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="currentPage"
        :page-sizes="[10, 20, 30, 50]"
        :page-size="pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total">
      </el-pagination>

      <div style="margin-top: 20px; text-align: right;">
        <el-button type="warning" @click="goBack" style="margin-right: 20px;">取消</el-button>
        <el-button type="primary" @click="doInoutOrder">提交</el-button>
      </div>
    </el-card>

    <choose-partner-goods ref="choosePartnerGoods" @chooseParknerGoods="handleChooseProduct"></choose-partner-goods>
  </div>
</template>

<script>
import { syncPartnerGoods } from '@/api/partner/transferPartnerGoodsApi'
import { getShopId } from '@/api/shop/shopApi'
import ChoosePartnerGoods from '@/components/partner/choosePartnerGoods'

export default {
  components: {
    ChoosePartnerGoods
  },
  data() {
    return {
      currentPage: 1,
      pageSize: 10,
      total: 0,
      transferPartnerGoodsInfo: {
        ppId: '',
        products: [],
        remark: '',
        shopId: ''
      }
    }
  },
  created() {
    this.initData()
  },
  methods: {
    initData() {
      this.transferPartnerGoodsInfo.ppId = this.$route.query.ppId
      this.transferPartnerGoodsInfo.shopId = getShopId()
    },
    handleChooseProduct(product) {
      const products = this.transferPartnerGoodsInfo.products
      const hasIn = products.some(p => p.valueId === product.valueId)
      if (hasIn) {
        this.$message.warning('请勿重复选择')
        return
      }
      products.push(product)
    },
    async doInoutOrder() {
      if (this.transferPartnerGoodsInfo.products.length < 1) {
        this.$message.warning('请选择商品')
        return
      }
      try {
        const res = await syncPartnerGoods(this.transferPartnerGoodsInfo)
        if (res.code === 0) {
          this.$message.success(res.msg)
          this.goBack()
        } else {
          this.$message.error(res.msg)
        }
      } catch (error) {
        this.$message.error('请求失败')
        console.error(error)
      }
    },
    openAddShopHouseModal() {
      this.$refs.choosePartnerGoods.open({
        ppId: this.transferPartnerGoodsInfo.ppId
      })
    },
    goBack() {
      this.$router.go(-1)
    },
    deleteProduct(product) {
      const index = this.transferPartnerGoodsInfo.products.indexOf(product)
      if (index > -1) {
        this.transferPartnerGoodsInfo.products.splice(index, 1)
      }
    },
    handleSizeChange(val) {
      console.log(val)
      this.pageSize = val
      // 这里可以添加获取数据的逻辑
    },
    handleCurrentChange(val) {
      console.log(val)
      this.currentPage = val
      // 这里可以添加获取数据的逻辑
    }
  }
}
</script>

<style scoped>
.box-card {
  margin: 20px;
}
</style>